// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"66615cf9","732":"9df9ba5d","977":"e2893e4d"}[chunkId] + ".chunk.js";
};